export default __webpack_public_path__ + "39c3aafae2a347621c2b06c36e724a2a.svg";